/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Storage key for available user storage types
 * @export
 * @enum {string}
 */
export enum UserStorageKey {
    PINNED_TABS = 'PINNED_TABS',
    GRID_VIEW_STATE = 'GRID_VIEW_STATE',
    RECENTLY_VIEWED_ENTITIES = 'RECENTLY_VIEWED_ENTITIES'
}



